module.exports = __webpack_public_path__ + "img/co-branding-world-RP-background-4.f3848ff2.png";